var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTermsCondition = function SvgTermsCondition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.144 17.911c2.132-.026 3.642-.143 4.628-.256a1.904 1.904 0 0 0 1.705-1.71c.133-1.204.275-3.225.275-6.362 0-1.198-.021-2.233-.054-3.123-.147-.41-.646-1.487-2.195-3.004-1.642-1.61-2.779-2.063-3.132-2.174a67 67 0 0 0-2.12-.032c-2.61 0-4.402.133-5.52.261a1.904 1.904 0 0 0-1.704 1.71c-.094.848-.192 2.1-.242 3.862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.703 6.65c-.87.13-2.434.03-3.62-.08a1.94 1.94 0 0 1-1.762-1.754c-.112-1.168-.211-2.695-.075-3.537M1.25 13.75a5 5 0 1 0 10 0 5 5 0 0 0-10 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.33 12.082-2.45 3.333-1.716-1.944"
  })));
};
export default SvgTermsCondition;